module.exports = __webpack_public_path__ + "static/media/constraint-screen.3d390849.png";